<template>
  <div class="row align-items-center">
  <div class="col-lg-5 d-flex justify-content-center">
    <div
      v-if="dataPath"
      class="icon-animate icon-animate--custom"
      :data-path="dataPath"
    ></div>
    <div v-if="src">
      <img class="img-fluid" :src="src" alt="" />
    </div>
  </div>
  <div class="col-lg-7">
    <div class="section__subtitle">
      {{ title }}
    </div>
    <div v-html="detail"></div>
  </div>
</div>
</template>

<script setup>
import { onMounted } from "vue";
import lottie from "lottie-web";
import { useLockScrollServiceCard } from "~/composables/useLockScrollServiceCard";
useLockScrollServiceCard();

// Define the props that the component will accept
const props = defineProps({
  src: {
    type: String,
    required: true,
  },
  dataPath: {
    type: String,
    required: true,
  },
  title: {
    type: String,
    required: true,
  },
  detail: {
    type: String,
    required: true,
  },
});

// Function to initialize Lottie animation
const animateIcon = () => {
  onMounted(() => {
    const elements = document.querySelectorAll(".icon-animate");

    if (elements.length) {
      elements.forEach((element) => {
        const path = element.dataset.path;

        // Animation script using lottie
        lottie.loadAnimation({
          container: element,
          renderer: "svg",
          loop: true,
          autoplay: true,
          path: path,
        });
      });
    }
  });
};

// Call the function to start animation when the component is mounted
animateIcon();
</script>

<style lang="scss" scoped>
@import "@/assets/scss/app";

.icon-animate {
  &.icon-animate--custom {
    width: 450px;
    height: 450px;
    margin-right: 11px;

    @include media-breakpoint-down(md) {
      margin-right: 0;
    }
    @include media-breakpoint-down(sm) {
      width: 348px;
      height: 348px;
      transform: translateY(0px);
    }
  }

}
</style>